var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","margin-top":"15%"}},[_c('h1',[_vm._v("404 : Not Found")]),_c('h3',[_vm._v("You are requesting a page that does not exist!")]),_c('h5',[_vm._v("Go back to homepage: "),_c('a',{attrs:{"href":"/"}},[_vm._v("Quotey Homepage")])])])
}]

export { render, staticRenderFns }